module.exports = __webpack_public_path__ + "static/she-said-48e186cb07b773b414e1513d7b77d43d.jpg";